<template>
  <DialogContainer
    :showDialog="showDialog"
    title="Add Activity Type"
    icon="add"
    :toolbarActions="[
      {
        text: 'Save',
        icon: 'save',
        buttonColor: 'success',
        emitEvent: 'onSubmitClicked',
        showIsLoading: true,
        isDisabledFunc: () => !isFormValid,
      },
      {
        text: 'Cancel',
        depressed: true,
        emitEvent: 'onCancelClicked',
      },
    ]"
    @onCancelClicked="onCancelClicked"
    @onSubmitClicked="onSubmitClicked"
    :isLoading="isLoading"
  >
    <v-container pa-0 grid-list-lg>
      <v-form v-model="isFormValid" ref="form">
        <v-layout wrap>
          <v-flex xs12>
            <ControlTextField
              label="Activity Type Name*"
              autofocus
              v-model="name"
              :disabled="isLoading"
              :rules="[(v) => !!v || 'Required']"
            />
          </v-flex>
          <v-flex xs12>
            <ControlCheckbox
              v-model="isLocationChange"
              label="Can the equipment location change after this activity?"
              :disabled="isLoading"
            />
          </v-flex>
          <v-flex xs12>
            <ControlCheckbox
              v-model="isStatusChange"
              label="Can the equipment status change after this activity?"
              :disabled="isLoading"
            />
          </v-flex>
          <v-flex xs12 v-if="isStatusChange">
            <ControlAutoComplete
              :items="enabledAssetStatuses"
              autocomplete
              multiple
              item-text="name"
              item-value="id"
              v-model="assetStatusIds"
              clearable
              label="Equipment statuses that can be set during this activity*"
              :disabled="isLoading"
              :rules="[(v) => (v && v.length > 0) || 'Required']"
            />
          </v-flex>
          <!-- <v-flex xs12>
          <ControlCheckbox
            v-model="isUpcoming"
            label="Is Upcoming?"
            :disabled="isLoading"
          />
        </v-flex> -->
        </v-layout>
        <small>*indicates required field</small>
      </v-form>
    </v-container>
  </DialogContainer>
</template>

<script>
import DialogContainer from '../../../common/components/layouts/DialogContainer'
import ControlTextField from '../../../common/components/controls/ControlTextField'
import ControlCheckbox from '../../../common/components/controls/ControlCheckbox'
import ControlAutoComplete from '../../../common/components/controls/ControlAutoComplete'

export default {
  components: {
    DialogContainer,
    ControlTextField,
    ControlCheckbox,
    ControlAutoComplete,
  },
  props: {
    showDialog: {
      type: Boolean,
      required: true,
    },
    assetStatusList: {
      type: Array,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    isFormValid: false,
    name: null,
    assetStatusIds: null,
    isStatusChange: null,
    isLocationChange: null,
    isUpcoming: null,
  }),
  computed: {
    enabledAssetStatuses() {
      return this.assetStatusList.filter((status) => status.isEnabled)
    },
  },
  watch: {
    showDialog() {
      if (!this.showDialog) {
        this.clearDialog()
      }
    },
    isStatusChange() {
      if (!this.isStatusChange) {
        this.assetStatusIds = null
      }
    },
  },
  methods: {
    onSubmitClicked() {
      this.$emit('onSubmitClicked', {
        name: this.name,
        assetStatusIds: this.assetStatusIds || [],
        isStatusChange: this.isStatusChange,
        isLocationChange: this.isLocationChange,
        isUpcoming: this.isUpcoming,
      })
    },
    onCancelClicked() {
      this.$emit('onCancelClicked')
    },
    clearDialog() {
      this.$refs.form.reset()
      this.name = null
      this.assetStatusIds = null
      this.isStatusChange = null
      this.isLocationChange = null
      this.isUpcoming = null
    },
  },
}
</script>